export const alignHMap = {
  stretch: 'stretch',
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
export const alignVMap = {
  stretch: 'stretch',
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};